import { useQuery } from 'react-query';
import { getPromptLibrary } from 'utils/API/co-manager';

export const usePromptLibrary = ({ enabled = true, key = 'getPromptLibrary', random = false } = {}) =>
  useQuery({
    queryKey: [key],
    queryFn: () => getPromptLibrary({ random }),
    enabled,
  });
